import { createVNode as o, mergeProps as d } from "vue";
import l from "../node_modules/@pf-ui/pf-icon-svg/es/asn/CameraFilledStandard.js";
import m from "../components/PfIcon.js";
const r = (a, e) => {
  const t = {
    ...a,
    ...e.attrs
  };
  return o(m, d(t, {
    icon: l
  }), null);
};
r.displayName = "CameraFilledStandard";
r.inheritAttrs = !1;
export {
  r as default
};
